import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=cb769d2c&scoped=true&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=cb769d2c&scoped=true&lang=scss&"
import style1 from "./PageFooter.vue?vue&type=style&index=1&id=cb769d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb769d2c",
  null
  
)

export default component.exports